import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Bit32Digest93igwk80hzmt as Bit32Digest } from './Bit32Digest.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        // Inline function 'kotlin.intArrayOf' call
        tmp.c53_1 = new Int32Array([1779033703, -1150833019, 1013904242, -1521486534, 1359893119, -1694144372, 528734635, 1541459225]);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
function init_org_kotlincrypto_hash_sha2_SHA256(_this__u8e3s4) {
  Companion_getInstance();
}
var SHA256Class;
function SHA256() {
  if (SHA256Class === VOID) {
    class $ extends Bit32Digest() {
      static l53() {
        Companion_getInstance();
        var $this = this.a53(256, Companion_getInstance().c53_1);
        init_org_kotlincrypto_hash_sha2_SHA256($this);
        return $this;
      }
    }
    initMetadataForClass($, 'SHA256', $.l53);
    SHA256Class = $;
  }
  return SHA256Class;
}
//region block: exports
export {
  SHA256 as SHA256nymudvmltc47,
};
//endregion

//# sourceMappingURL=SHA256.mjs.map
